import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// PizzaBill project (billing software)
const firebaseConfig = {
  apiKey: "AIzaSyAQDx8wmgNa7N1E59tVC5OhvFykNPLlkP0",
  authDomain: "vip-pizza-62d4b.firebaseapp.com",
  projectId: "vip-pizza-62d4b",
  storageBucket: "vip-pizza-62d4b.firebasestorage.app",
  messagingSenderId: "715870797561",
  appId: "1:715870797561:web:e71f9b20ee1f64cd042c28",
  measurementId: "G-PFGQPLNGYC"
};

// VIP Pizza Order website project (read-only for website orders)
const orderConfig = {
  apiKey: "AIzaSyCmeOQEFttHTkufAH6_ktX_KULZSq4yNAs",
  authDomain: "vip-pizza-order.firebaseapp.com",
  projectId: "vip-pizza-order",
  storageBucket: "vip-pizza-order.firebasestorage.app",
  messagingSenderId: "136895471183",
  appId: "1:136895471183:web:b541238e7de0a906a9143a",
  measurementId: "G-J2BR0NSFHG"
};

const app      = initializeApp(firebaseConfig);
const orderApp = initializeApp(orderConfig, 'orderApp');

export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const orderDb = getFirestore(orderApp);
export const orderAuth = getAuth(orderApp);